import { h } from 'preact';
import { isFocusStudio, getCurrentRegionCode } from 'utils/studioConfig';

import HubPageEditor from 'components/editor/pages/hubPageEditor';
import UniversalAboutEditor from 'components/editor/pages/about/aboutUniversal';
import UniversalAboutTimelineEditor from 'components/editor/pages/about/timeline/timeline';
import FocusAboutEditor from 'components/editor/pages/about/aboutFocus';

export default class GlobalAboutEditor extends HubPageEditor {
	render(props) {
		if (isFocusStudio()) {
			return <FocusAboutEditor {...props} />;
		}
		const thundr = this.state.thundrData;
		// To avoid a flash of a different editor, predict based on expected data
		const useTimeline = !thundr ? /^us|^ca/.test(getCurrentRegionCode()) : thundr.pages?.about?.page === 'aboutTimeline';
		if (useTimeline) {
			return <UniversalAboutTimelineEditor {...props} />;
		}
		return <UniversalAboutEditor {...props} />;
	}
}